import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import * as moment from "moment";
import { confirm } from 'devextreme/ui/dialog';
import { ForecastDetail } from "../forecast-detail";
import { DxDataGridComponent } from "devextreme-angular";
import { ForecastService } from '../../../../../_api/services/forecast.service';
import { LanguageService } from '../../../../../shared/services/language.service';
import { AmsNotifierService } from '../../../../../shared/services/ams-notifier.service';

@Component({
  selector: 'app-forecast-detail-orders',
  templateUrl: './forecast-detail-orders.component.html',
  styleUrls: ['./forecast-detail-orders.component.css']
})
export class ForecastDetailOrdersComponent implements OnInit, OnChanges {

  selectedDateForecastOrders = moment();
  dataSourceForecastOrders: any;
  columnsForecastOrders: any[];
  titleForecastOrders = "";

  selectedDateHistoryOrders = moment().subtract(1, 'year');
  dataSourceHistoryOrders: any;
  columnsHistoryOrders: any[];
  titleHistoryOrders = "";
  titleCount = "Antall";
  titleSum = "Summert";

  @Input() wmsArticleId = -1;
  @Input() isAdding = false;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent to show load indicator
  @Output() selectedDateForecastOrdersChanged = new EventEmitter<any>();
  @Output() selectedDateHistoryOrdersChanged = new EventEmitter<any>();

  @ViewChild('dataGridForecastOrders', {static:false}) dataGridForecastOrders: DxDataGridComponent;

  constructor(private forecastService: ForecastService, private languageService: LanguageService, private amsNotifierService: AmsNotifierService) { }

  ngOnInit() {
    this.columnsForecastOrders = [
      { dataField: 'OrderNumber', caption: this.languageService.LNG('Label.OrderNumber'), width: 200, allowEditing: false },
      { dataField: 'Description', caption: this.languageService.LNG('Label.Description'), width: 300 },
      { dataField: 'Jan', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.January'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Feb', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.February'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Mar', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.March'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Apr', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.April'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'May', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.May'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'June', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.June'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'July', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.July'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Aug', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.August'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Sep', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.September'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Oct', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.october'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Nov', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.november'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Dec', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.december'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
    ];
    this.titleForecastOrders = this.languageService.LNG("Label.Forecast.Orders");

    this.columnsHistoryOrders = [
      { dataField: 'Type', caption: " ", width: 150, cellTemplate: "cellTemplateType" },
      { dataField: 'Jan', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.January'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Feb', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.February'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Mar', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.March'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Apr', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.April'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'May', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.May'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'June', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.June'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'July', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.July'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Aug', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.August'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Sep', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.September'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Oct', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.october'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Nov', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.november'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
      { dataField: 'Dec', caption: this.languageService.LNG('dxAllAms.MonthsAbbr.december'), dataType: 'number', format: { day: '2-digit', month: '2-digit', year: 'numeric' } },
    ];
    this.titleHistoryOrders = this.languageService.LNG("Label.History.Orders");
    this.titleCount = this.languageService.LNG("Label.Count.Orders");
    this.titleSum = this.languageService.LNG("Label.Quantity.Sold");
  }

  ngOnChanges() {
    
    if (this.wmsArticleId > 0) {
      this.loadOrderForecast();
      this.loadHistoryOrders();
    }
    else {
      this.dataSourceForecastOrders = [];
      this.dataSourceHistoryOrders = [];
    }
  }

  initDetail(detail: ForecastDetail) {
    this.wmsArticleId = detail.wmsArticleId;
    this.isAdding = detail.isAdding;
    this.selectedDateForecastOrders = detail.selectedForecastOrderDate;
    this.selectedDateHistoryOrders = detail.selectedHistoryOrderDate;
  }

  dateChangedForecastOrders(dateInterval: any) {
    
    this.selectedDateForecastOrders = moment(dateInterval.FromDate);
    this.selectedDateForecastOrdersChanged.emit(this.selectedDateForecastOrders);
    this.loadOrderForecast();
  }

  loadOrderForecast() {
    
    this.loading.emit(true);
    this.dataSourceForecastOrders = this.forecastService.getOrderForecast(this.wmsArticleId, this.selectedDateForecastOrders.year()).subscribe((result: any) => {
      this.loading.emit(false);
      
      if (result.IsSuccess) {
        if (result.Message) {
          this.amsNotifierService.warning(result.Message);
        }
        this.dataSourceForecastOrders = result.Data;
      }
      else {

      }
    }, error => { // error path;

      this.loading.emit(false);
    });;
  }

  calculateSummary(options) {

    // Calculating "customDaysManuallyCreatedToAssignedShipment"
    if(options.name.indexOf("customSum") > -1) {
      
      switch(options.summaryProcess) {
        case "start":
            // Initializing "totalValue" here
            options.totalValue = 0;
            break;
        case "calculate":
              switch(options.name) {
                case "customSumJan":
                  options.totalValue = options.totalValue + options.value.Jan;
                break;
                case "customSumFeb":
                  options.totalValue = options.totalValue + options.value.Feb;
                break;
                case "customSumMar":
                  options.totalValue = options.totalValue + options.value.Mar;
                break;
                case "customSumApr":
                  options.totalValue = options.totalValue + options.value.Apr;
                break;
                case "customSumMay":
                  options.totalValue = options.totalValue + options.value.May;
                break;
                case "customSumJune":
                  options.totalValue = options.totalValue + options.value.June;
                break;
                case "customSumJuly":
                  options.totalValue = options.totalValue + options.value.July;
                break;
                case "customSumAug":
                  options.totalValue = options.totalValue + options.value.Aug;
                break;
                case "customSumSep":
                  options.totalValue = options.totalValue + options.value.Sep;
                break;
                case "customSumOct":
                  options.totalValue = options.totalValue + options.value.Oct;
                break;
                case "customSumNov":
                  options.totalValue = options.totalValue + options.value.Nov;
                break;
                case "customSumDec":
                  options.totalValue = options.totalValue + options.value.Dec;
                break;

              }
            // Modifying "totalValue" here
            break;
        case "finalize":
            // Assigning the final value to "totalValue" here
            options.totalValue = Number(options.totalValue).toLocaleString();
            break;
    }
    }
};

  saveEditData() {
    this.dataGridForecastOrders.instance.saveEditData();
  }

  onRowInsertingForecastOrders(e) {
    const isCanceled = new Promise((resolve) => {
      let rec = e.data;
      if (rec.Jan || rec.Feb || rec.Mar || rec.Apr || rec.May || rec.June || rec.July || rec.Aug || rec.Sep || rec.Oct || rec.Nov || rec.Dec) {
        this.loading.emit(true);
        rec.WMSArticleId = this.wmsArticleId;
        rec.DeliveryDateYear = this.selectedDateForecastOrders.year();
        this.forecastService.postOrderForecast(rec)
          .subscribe((result: any) => { // success path            
            this.loading.emit(false);
            if (result.IsSuccess) {
              resolve(false);
              this.amsNotifierService.success(this.languageService.LNG('Label.SavedOK'));
              e.component.cancelEditData();
              this.loadOrderForecast();
            }
            else {
              this.amsNotifierService.errorWithTimeout(result.ErrorMessage);
              resolve(true);
            }
          }, error => { // error path;
            this.amsNotifierService.errorWithTimeout(error.message);
            resolve(true);
          });
      }
      else {
        this.amsNotifierService.errorWithTimeout(this.languageService.LNG("Label.Please.Enter.Some.Forecasts.In.Order.To.Save"));
        resolve(true);
      }
    });
    e.cancel = isCanceled;
  }

  onRowUpdatingForecastOrders(e) {
    const isCanceled = new Promise((resolve) => {
      let rec = Object.assign(e.oldData, e.newData);
      if (rec.Jan || rec.Feb || rec.Mar || rec.Apr || rec.May || rec.June || rec.July || rec.Aug || rec.Sep || rec.Oct || rec.Nov || rec.Dec) {
        this.updateOrderForecast(rec, e.component);
        resolve(false);
      }
      else {
        confirm(this.languageService.LNG("Label.No.Forecasts.Do.You.Want.To.Delete.This.Order"), this.languageService.LNG("Label.Delete.Order")).then((yes) => {
          if (yes) {
            this.loading.emit(true);
            this.forecastService.deleteOrder(this.wmsArticleId, e.oldData.OrderId)
              .subscribe((result: any) => { // success path                
                this.loading.emit(false);
                if (result.IsSuccess) {
                  resolve(false);
                  this.amsNotifierService.success(this.languageService.LNG('Label.DeletedOK'));
                  e.component.cancelEditData();
                  this.loadOrderForecast();
                }
                else {
                  this.amsNotifierService.success(this.languageService.LNG(result.ErrorMessage));
                  resolve(true);
                }
              }, error => { // error path;
                this.amsNotifierService.error(error.message);
                resolve(true);
              });
          }
          else {
            this.updateOrderForecast(rec, e.component);
            resolve(false);
          }
        });
      }
    });
    e.cancel = isCanceled;
  }

  updateOrderForecast(rec: any, dxDataGridComponent: any) {
    this.loading.emit(true);
    rec.WMSArticleId = this.wmsArticleId;
    this.forecastService.putOrderForecast(rec)
      .subscribe((result: any) => { // success path
        
        this.loading.emit(false);
        if (result.IsSuccess) {
          this.amsNotifierService.success(this.languageService.LNG('Label.SavedOK'));
          dxDataGridComponent.cancelEditData();
          this.loadOrderForecast();
        }
        else {
          this.amsNotifierService.errorWithTimeout(result.ErrorMessage);
        }
    }, error => { // error path;
      this.amsNotifierService.errorWithTimeout(error.message);
    });
  }

  onRowRemovingForecastOrders(e) {
    
    this.forecastService.deleteOrder(this.wmsArticleId, e.data.OrderId)
      .subscribe((result: any) => { // success path
        
        if (result.IsSuccess) {
          this.amsNotifierService.success(this.languageService.LNG('Label.DeletedOK'));
        }
        else {
          this.amsNotifierService.success(this.languageService.LNG(result.ErrorMessage));
        }
    }, error => { // error path;
      this.amsNotifierService.error(error.message);
    });
  }

  onInitNewRowForecastOrders(e) {

  }

  dateChangedHistoryOrders(dateInterval: any) {
    
    this.selectedDateHistoryOrders = moment(dateInterval.FromDate);
    this.selectedDateHistoryOrdersChanged.emit(this.selectedDateHistoryOrders)
    this.loadHistoryOrders();
  }

  loadHistoryOrders() {
    
    this.loading.emit(true);
    this.dataSourceHistoryOrders = this.forecastService.getHistoryOrders(this.wmsArticleId, this.selectedDateHistoryOrders.year()).subscribe((result: any) => {
      this.loading.emit(false);
      if (result.IsSuccess) {
        this.dataSourceHistoryOrders = result.Data;
      }
      else {

      }
    }, error => { // error path;

      this.loading.emit(false);
    });;
  }

  @Input()
  set setSelectedDateForecastOrders(date: any) {
    
    if (this.selectedDateForecastOrders) {
      // let selectedDate = this.selectedDateForecastOrders.year(year);
      this.selectedDateForecastOrders = date;
    }
  }

}
